export default {
  //apiBaseUrl: "https://localhost:7258/",
  //apiBaseUrl: "https://mglz-dev.azurewebsites.net/",
  //apiBaseUrl: "https://mglz.us/",
  apiBaseUrl: "https://mgl.to/",
};
